import type { AppAction } from "./../app.types"
export interface IIndexState {
  history: Breadcrumb[]
}

export type Breadcrumb = {
  type: PageType
  id: string
  name: string
}

export enum PageType {
  Index = 0,
  Chapter = 1,
  Region = 2,
  Theme = 3
}

export type IndexActions = IndexAction | IndexPageAction
export type IndexAction = AppAction<Breadcrumb>
export type IndexPageAction = AppAction<string>
